import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import cup from "../../../../../../../../assets/images/cup 2.png";
import AuditionCardReuse from "../../../../../../../AuditionAdmin/AuditionCardReuse";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";

const PostList = () => {
  const [events, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/audition-admin/audition/post_list").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.events);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Audition Lists" image={cup} count={"Zero"} />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionCardReuse
          data={events}
          // urlLink={`/audition-admin/audition/event/request-approve`}
          viewPostUrl={`/audition-admin/audition/event/request-approve`}
        />
      )}
    </>
  );
};

export default PostList;
